import angular from 'angular';
import uiRouter from 'angular-ui-router';
import bankTxesComponent from './banktxes.component';
import dataTable from 'angular-material-data-table';

let bankTxesModule = angular.module('bankTxes', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('bankTxes', {
        url: '/bankTxes',
        component: 'bankTxes',
        parent: 'main',
        data: {
            permissions: {
                only: ['ADMIN'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('bankTxes', bankTxesComponent)
.name;

export default bankTxesModule;
